export { RedirectToMobile } from './redirect-to-mobile'
